import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6965076e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["open"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  role: "status"
}
const _hoisted_8 = {
  key: 1,
  class: "hr-journal-error",
  role: "alert"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "hr-journal-date" }
const _hoisted_13 = {
  key: 0,
  class: "hr-journal-actor-id"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["aria-label"]

import { onMounted, onBeforeUnmount, reactive, ref, watch } from "vue";
import { Button } from "@/components/common";
import PublicId from "@/components/common/PublicId.vue";
import HrDataService from "@/services/hr/HrDataService";
import { HrAuditEntry } from "@/types/hr/Hr";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: { employeeId: { type: String, default: "" } },
  setup(__props) {

const props = __props

/* global defineProps */

const entries = ref<HrAuditEntry[]>([]);
const loading = ref(false);
const error = ref("");
const page = ref(1);
const totalPages = ref(0);
const filters = reactive({ action: "", from: "", to: "" });
let opened = !props.employeeId;
let initialized = false;
let requestVersion = 0;
const actions = [
  "EMPLOYEE_CREATED",
  "EMPLOYEE_UPDATED",
  "EMPLOYEE_ARCHIVED",
  "DOCUMENT_CREATED",
  "DOCUMENT_UPDATED",
  "DOCUMENT_ARCHIVED",
  "DOCUMENT_READ",
  "DOCUMENT_TYPE_CREATED",
  "DOCUMENT_TYPE_UPDATED",
  "DOCUMENT_TYPE_ARCHIVED",
  "EMPLOYEE_TYPE_CREATED",
  "EMPLOYEE_TYPE_UPDATED",
  "EMPLOYEE_TYPE_ARCHIVED",
  "REQUIREMENT_CREATED",
  "REQUIREMENT_UPDATED",
  "REQUIREMENT_DELETED",
  "SETTINGS_CREATED",
  "SETTINGS_UPDATED",
  "NOTIFICATION_CREATED",
  "NOTIFICATION_UPDATED",
  "MAIL_UPDATED",
];

function date(value: string) {
  const utc = /(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? value : `${value}Z`;
  const parsed = new Date(utc);
  return Number.isNaN(parsed.getTime()) ? "—" : parsed.toLocaleString();
}
function field(value: string) {
  const key = `hr.audit.field.${value}`;
  const label = t(key);
  return label === key ? value : label;
}
function reason(value: string) {
  const key = `hr.deliveryReason.${value}`;
  const label = t(key);
  return label === key ? t("hr.audit.processingError") : label;
}
function result(entry: HrAuditEntry) {
  if (entry.action === "MAIL_UPDATED")
    return t(`hr.audit.mail.${entry.status}`);
  if (entry.action.startsWith("NOTIFICATION_"))
    return t(`hr.delivery.${entry.status}`);
  return t("hr.audit.committed");
}
async function load(nextPage = 1) {
  if (loading.value) return;
  if (filters.from && filters.to && filters.from > filters.to) {
    error.value = t("hr.audit.invalidDates");
    return;
  }
  const version = ++requestVersion;
  loading.value = true;
  error.value = "";
  try {
    const response = await HrDataService.getAudit({
      employeeId: props.employeeId || undefined,
      action: filters.action || undefined,
      from: filters.from || undefined,
      to: filters.to || undefined,
      page: nextPage,
    });
    if (version !== requestVersion) return;
    if (!response.data.status || !response.data.data)
      throw new Error("Invalid journal response");
    entries.value = response.data.data.items;
    page.value = response.data.data.pager.currentPage;
    totalPages.value = response.data.data.pager.totalPages;
    initialized = true;
  } catch {
    if (version === requestVersion) {
      entries.value = [];
      error.value = t("hr.audit.loadError");
    }
  } finally {
    if (version === requestVersion) loading.value = false;
  }
}
function onToggle(event: Event) {
  opened = (event.target as HTMLDetailsElement).open;
  if (opened && !initialized) load();
}
watch(
  () => props.employeeId,
  () => {
    requestVersion++;
    loading.value = false;
    initialized = false;
    entries.value = [];
    error.value = "";
    page.value = 1;
    totalPages.value = 0;
    if (opened) load();
  }
);
onMounted(() => {
  if (!props.employeeId) load();
});
onBeforeUnmount(() => {
  requestVersion++;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("details", {
    class: "hr-journal",
    open: !__props.employeeId,
    onToggle: onToggle
  }, [
    _createElementVNode("summary", null, _toDisplayString(_unref(t)("hr.audit.title")), 1),
    _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.audit.hint")), 1),
    _createElementVNode("form", {
      class: "hr-journal-filters",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (load(1)), ["prevent"]))
    }, [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)("hr.audit.action")) + " ", 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).action) = $event)),
          class: "input-form",
          disabled: loading.value
        }, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_unref(t)("hr.all")), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (action) => {
            return _createElementVNode("option", {
              key: action,
              value: action
            }, _toDisplayString(_unref(t)(`hr.audit.action.${action}`)), 9, _hoisted_4)
          }), 64))
        ], 8, _hoisted_2), [
          [_vModelSelect, _unref(filters).action]
        ])
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)("hr.audit.from")), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).from) = $event)),
          type: "date",
          class: "input-form",
          disabled: loading.value
        }, null, 8, _hoisted_5), [
          [_vModelText, _unref(filters).from]
        ])
      ]),
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_unref(t)("hr.audit.to")), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).to) = $event)),
          type: "date",
          class: "input-form",
          disabled: loading.value
        }, null, 8, _hoisted_6), [
          [_vModelText, _unref(filters).to]
        ])
      ]),
      _createVNode(_unref(Button), {
        type: "submit",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.search")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        type: "button",
        variant: "default",
        disabled: loading.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (load(page.value)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("hr.audit.refresh")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 32),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)("hr.loading")), 1))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(error.value), 1))
        : (!entries.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)("hr.audit.empty")), 1))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "hr-journal-scroll",
              tabindex: "0",
              "aria-label": _unref(t)('hr.audit.title')
            }, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.audit.date")), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.audit.action")), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.audit.actor")), 1),
                    (!__props.employeeId)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_unref(t)("hr.audit.employee")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.audit.result")), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.audit.details")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: entry.eventId
                    }, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(date(entry.occurredAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(t)(`hr.audit.action.${entry.action}`)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(entry.actorName || _unref(t)("hr.audit.system")), 1),
                        (entry.actorId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(PublicId, {
                                value: entry.actorId,
                                compact: ""
                              }, null, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!__props.employeeId)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                            (entry.employeeId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: {
                  name: 'HrEmployeeDetails',
                  params: { id: entry.employeeId },
                }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(entry.employeeName || entry.employeeId), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(result(entry)), 1),
                        (entry.reasonCode)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(reason(entry.reasonCode)), 1))
                          : _createCommentVNode("", true),
                        (entry.source === 'NOTIFICATION')
                          ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_unref(t)("hr.audit.smtpAttempt")) + ": " + _toDisplayString(entry.attempt), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("details", null, [
                          _createElementVNode("summary", null, _toDisplayString(_unref(t)("hr.audit.details")), 1),
                          _createElementVNode("dl", null, [
                            _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.subject")), 1),
                            _createElementVNode("dd", null, [
                              _createVNode(PublicId, {
                                value: entry.subjectId,
                                compact: ""
                              }, null, 8, ["value"])
                            ]),
                            (entry.relatedId)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.related")), 1),
                                  _createElementVNode("dd", null, [
                                    _createVNode(PublicId, {
                                      value: entry.relatedId,
                                      compact: ""
                                    }, null, 8, ["value"])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.event")), 1),
                            _createElementVNode("dd", null, [
                              _createVNode(PublicId, {
                                value: entry.eventId,
                                compact: ""
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.operation")), 1),
                            _createElementVNode("dd", null, [
                              _createVNode(PublicId, {
                                value: entry.operationId,
                                compact: ""
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.source")), 1),
                            _createElementVNode("dd", null, _toDisplayString(_unref(t)(`hr.audit.source.${entry.source}`)), 1),
                            (entry.changedFields.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.fields")), 1),
                                  _createElementVNode("dd", null, _toDisplayString(entry.changedFields.map(field).join(", ")), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("dt", null, _toDisplayString(_unref(t)("hr.audit.recorded")), 1),
                            _createElementVNode("dd", null, _toDisplayString(date(entry.recordedAt)), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 8, _hoisted_10)),
    (!loading.value && !error.value && totalPages.value > 1)
      ? (_openBlock(), _createElementBlock("nav", {
          key: 4,
          class: "hr-journal-pages",
          "aria-label": _unref(t)('hr.audit.pages')
        }, [
          _createVNode(_unref(Button), {
            type: "button",
            variant: "default",
            disabled: page.value <= 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (load(page.value - 1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("hr.audit.previous")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("span", null, _toDisplayString(page.value) + " / " + _toDisplayString(totalPages.value), 1),
          _createVNode(_unref(Button), {
            type: "button",
            variant: "default",
            disabled: page.value >= totalPages.value,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (load(page.value + 1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("hr.audit.next")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 8, _hoisted_18))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})